<template>
  <div
    class="i-landing-logo"
    :class="{ vis: visible }"
    @click="goToFirstStep"
  >
    JobTest<em>.</em>org
  </div>
</template>

<script setup>
import { useRouter } from "vue-router"

import { GlobalVariables } from "@/helpers/globalVariables"

defineProps({
  visible: Boolean
})

// ROUTES
const router = useRouter()

// FUNCTIONS
const goToFirstStep = () => {
  router.push({
    name: GlobalVariables.urls.firstStep.routeName
  })
}
</script>

<style lang="scss" scoped>
.i-landing-logo {
  font-family: $serif;
  font-size: 18px;
  font-weight: 500;
  color: #111827d1;
  text-decoration: none;
  letter-spacing: -0.2px;
  opacity: 0;
  transition: opacity 0.5s ease 0.05s;

  &.vis {
    opacity: 1;
  }

  em {
    font-style: normal;
    color: $amber-mid;
  }
}
</style>
